export default __webpack_public_path__ + "static/media/Y10.dd45a224.jpg";